import { Add, ErrorOutline } from "@mui/icons-material";
import { Alert, Box, Button, CircularProgress, Link, Tooltip } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AllSetUpModal from "../modals/AllSetUpModal";
import planData from "../plans.json";
import { jwtDecode } from "jwt-decode";
import decryptApi from "../utils/decryptApi";
import { Edit, Phone, Plus } from "lucide-react";
import { formatPhoneNumber } from "../utils/formatnumber";

const productionVoiceUrl = (routeId) =>
  `https://incoming.twilanswer.com/${routeId}`;
const devVoiceUrl = (routeId) =>
  `https://incoming.twilanswer.com/dev/${routeId}`;

const TWILIO_SETUP_DOCS_URL =
  "https://twilanswer.com/docs/how-to-point-your-twilio-number-to-your-twilanswer-account";

const setRouteStatusBadge = (wrapperEl, html) => {
  if (!wrapperEl) return;
  const badge = wrapperEl.querySelector("[data-route-status-badge]");
  if (badge) badge.innerHTML = html;
  wrapperEl.hidden = false;
};

const ROUTE_STATUS_TOOLTIP_TEXT = "text-[15px] leading-snug";

const routeStatusTooltipLinkSx = {
  color: "inherit",
  fontWeight: 600,
  fontSize: "15px",
};

const routeStatusTooltips = {
  connected: (
    <span className={ROUTE_STATUS_TOOLTIP_TEXT}>
      All good here 👍. Your calls should be flowing.
    </span>
  ),
  connectedDev: (
    <span className={ROUTE_STATUS_TOOLTIP_TEXT}>
      Your route is using our latest call routing logic on our development
      servers.{" "}
      <Link
        component="a"
        href="mailto:hello@twilanswer.com"
        underline="always"
        sx={routeStatusTooltipLinkSx}
        onClick={(e) => e.stopPropagation()}
      >
        Contact support
      </Link>{" "}
      if you need help.
    </span>
  ),
  disconnected: (
    <span className={ROUTE_STATUS_TOOLTIP_TEXT}>
      This phone number is not connected to this route.{" "}
      <Link
        component="a"
        href={TWILIO_SETUP_DOCS_URL}
        target="_blank"
        rel="noopener noreferrer"
        underline="always"
        sx={routeStatusTooltipLinkSx}
        onClick={(e) => e.stopPropagation()}
      >
        Learn how to point your Twilio number to Twilanswer
      </Link>
    </span>
  ),
};

const CallRoutings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [openAllSetUpModal, setOpenAllSetupModal] = useState(false);

  const [planDetails, setPlanDetails] = useState(null);
  const check_subscription = async () => {
    try {
      setLoader(true);
      let sub = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "stripe/check-subscription",
        {
          organization_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
          customer_id: JSON.parse(localStorage.getItem("organization"))
            .subscription_details.M.stripe_cust_id.S,
        }
      );

      setPlanDetails(planData[sub.data?.planDetails[0].plan_id]);
      return;
    } catch (error) {
      // Log for production diagnostics when subscription check fails
      console.error("CallRoutings: check subscription failed", error.response?.data || error.message || error);
      if (error.response && error.response.data) {
        setErrorMsg(error.response.data.message);
      }
      setLoader(false);
    }
  };
  useEffect(() => {
    check_subscription();
  }, []);

  const [loader, setLoader] = useState(true);
  const [error_msg, setErrorMsg] = useState(null);
  const [routes, setRoutes] = useState(null);

  const getRoutes = async () => {
    try {
      let routes = await axios.post(
        process.env.REACT_APP_BACKEND_URL + "route/get-routes",
        { org_id: JSON.parse(localStorage.getItem("organization")).orgId.S }
      );

      setRoutes(routes.data.routes);
      setLoader(false);
    } catch (error) {
      // Log for production diagnostics when get routes fails
      console.error("CallRoutings: get routes failed", error.response?.data || error.message || error);
      if (error.response && error.response.data) {
        setErrorMsg(error.response.data.message);
      }
      setLoader(false);
    }
  };

  // const getCalls = async (route_id) => {

  //   try {
  //     let calls = await axios.post(
  //       process.env.REACT_APP_BACKEND_URL + "call/get-calls-by-route",
  //       { route_id, organization_id : JSON.parse(localStorage.getItem("organization")).orgId.S  }
  //     );

  //     setLoader(false);
  //     console.log('jo')
  //     console.log(calls)
  //     function filterCallsLast30Days() {
  //       const now = Date.now();
  //       const thirtyDaysAgo = now - 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

  //       return  calls.data.calls.filter(call => {
  //         const timestamp = parseInt(call.startTime.N, 10); // Convert N field to a number
  //         return timestamp >= thirtyDaysAgo && timestamp <= now;
  //       });
  //     }
  //     console.log('ejwe',filterCallsLast30Days())

  //     let recentCalls = filterCallsLast30Days();
  //     console.log('recent_calls', recentCalls)
  //     return recentCalls;
  //   } catch (error) {
  //     console.log(error);
  //     if (error.response && error.response.data) {
  //       console.error("Response data:", error.response.data);
  //       setErrorMsg(error.response.data.message);
  //     }
  //     setLoader(false);
  //   }

  // };
  const [callsData, setCallsData] = useState({});

  useEffect(() => {
    getRoutes();
  }, []);

  useEffect(() => {
    //   const fetchCalls = async () => {
    //     let data = {};
    //     for (const route of routes) {
    //       const calls = await getCalls(route.routeId.S); // Assuming getCalls returns the calls
    //       data[route.routeId.S] = calls?.length; // Store the length of calls for each route
    //     }
    //     console.log('data',data)
    //     setCallsData(data);
    //   };
    //  if(routes){
    //   fetchCalls();
    //  }
  }, [routes]);

  return (
    <div className="pt-7 px-4 w-full ">
      <div className="lg:text-[17px] text-[15px] flex justify-between font-semibold mb-4 w-full">
        <div className="flex  justify-between w-full items-center">
          <div className="lg:text-[22px] text-[20px] font-bold mb-4 lg:mt-0 mt-8 ">
            Call Routes
          </div>

          <div>
            {loader ? (
              <div className="flex justify-center pr-2">
                <CircularProgress
                  size={"1.2rem"}
                  color="primary"
                  sx={{ animationDuration: "0.7s" }}
                />
              </div>
            ) : (
              <>
                {routes?.length >= planDetails?.inbound_numbers ? (
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      py: "5px",
                      px: "10px",
                      borderRadius: "12px",
                      fontSize: { lg: "14px", xs: "12px" },
                    }}
                    onClick={() => {
                      navigate("/dashboard/settings/billing");
                    }}
                  >
                    <Add
                      sx={{ fontSize: "20px", position: "relative", bottom: 1 }}
                    />
                    Upgrade Plan to add more Routes
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      py: "5px",
                      px: "10px",
                      borderRadius: "7px",
                      fontSize: { lg: "14px", xs: "12px" },
                      fontWeight: 700,
                    }}
                    onClick={() => {
                      navigate("/dashboard/create-route");
                    }}
                    //disabled={ ! (/^\(\d{3}\) \d{3}-\d{4}$/.test(call_data.recipient))}
                  >
                    <Plus className="w-[20px]" />
                    New Route
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {error_msg && (
        <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
          <ErrorOutline sx={{ fontSize: "" }} /> {error_msg}
        </div>
      )}

      <div className="space-y-8 w-full">
        {routes && routes.length > 0 ? (
          routes.map((route, index) => {
            //get phone numbers
            let t = JSON.parse(localStorage.getItem("organization"))
              .twilio_integration.M;

            const getPhoneNumber = async () => {
              try {
                let phoneNumber_ = await axios.post(
                  process.env.REACT_APP_BACKEND_URL + "twilio/get-phone-number",
                  {
                    org_id: JSON.parse(localStorage.getItem("organization")).orgId.S,
                    phone_number: route.configured_phone.S,
                  }
                );

                const connectedEl = document.getElementById("connected-" + index);
                const connectedDevEl = document.getElementById("connected-dev-" + index);
                const disconnectedEl = document.getElementById("disconnected-" + index);
                const loaderEl = document.getElementById("loader-" + index);
                const voiceUrl = phoneNumber_.data.voiceUrl;
                const routeId = route.routeId.S;

                const hideStatusBadges = () => {
                  if (connectedEl) connectedEl.hidden = true;
                  if (connectedDevEl) connectedDevEl.hidden = true;
                  if (disconnectedEl) disconnectedEl.hidden = true;
                  if (loaderEl) loaderEl.hidden = true;
                };

                if (voiceUrl === productionVoiceUrl(routeId)) {
                  hideStatusBadges();
                  setRouteStatusBadge(
                    connectedEl,
                    `<span style="height:7px;width:7px;background:#34C759;border-radius:50%;
display:inline-block;margin-right:6px;position:relative;bottom:1px;"></span>Connected`
                  );
                } else if (voiceUrl === devVoiceUrl(routeId)) {
                  hideStatusBadges();
                  setRouteStatusBadge(
                    connectedDevEl,
                    `<span style="height:7px;width:7px;background:#F59E0B;border-radius:50%;
display:inline-block;margin-right:6px;position:relative;bottom:1px;"></span>Connected-Dev Route`
                  );
                } else {
                  hideStatusBadges();
                  setRouteStatusBadge(
                    disconnectedEl,
                    `<span style="height:7px;width:7px;background:#FF3B30;border-radius:50%;
display:inline-block;margin-right:6px;position:relative;bottom:1px;"></span>Disconnected`
                  );
                }
              } catch (error) {
                // Log for production diagnostics when phone number status check fails
                console.error("CallRoutings: get phone number status failed", error.response?.data || error.message || error);
                if (error.response && error.response.data) {
                  setErrorMsg(error.response.data.message);
                }
                const connectedEl = document.getElementById("connected-" + index);
                const connectedDevEl = document.getElementById("connected-dev-" + index);
                const disconnectedEl = document.getElementById("disconnected-" + index);
                const loaderEl = document.getElementById("loader-" + index);
                if (connectedEl) connectedEl.hidden = true;
                if (connectedDevEl) connectedDevEl.hidden = true;
                setRouteStatusBadge(
                  disconnectedEl,
                  `<span style="height:7px;width:7px;background:#FF3B30;border-radius:50%;
display:inline-block;margin-right:6px;position:relative;bottom:1px;"></span>Disconnected`
                );
                if (loaderEl) loaderEl.hidden = true;
              }
            };

            getPhoneNumber();

            //  const getCallsByRoute = async()=> {
            //   let calls = await axios.post(
            //     process.env.REACT_APP_BACKEND_URL + "call/get-calls-by-route",
            //     {route_id: route.routeId.S, organization_id : JSON.parse(localStorage.getItem("organization")).orgId.S  }
            //   );

            //     const now = Date.now();
            //     const thirtyDaysAgo = now - 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

            //     let rc =  calls.data.calls.filter(call => {
            //       const timestamp = parseInt(call.startTime.N, 10); // Convert N field to a number
            //       return timestamp >= thirtyDaysAgo && timestamp <= now;
            //     });
            //   console.log('ejwe',rc)

            //     if( document.getElementById('rc-'+index)){
            //       document.getElementById('rc-'+index).innerHTML = rc.length

            //     }

            //  }

            //  getCallsByRoute()
            return (
              <div className="space-y-8 w-full">
                <div className="border-[1px] border-[#E6E8EC] bg-white rounded-[10px] px-4 py-2 lg:py-6 space-y-1 w-full shadow-sm hover:shadow-md transition-shadow  duration-500 ease-in-out cursor-pointer">
                  <div className="flex items-center justify-between w-full mb-2">
                    <div>
                      {" "}
                      <div className=" lg:text-[15px] space-x-2   text-black flex items-center">
                        <div className="text-[18px] font-semibold">
                          {" "}
                          {route.name.S}{" "}
                        </div>

                        <div id={"loader-" + index}>
                          <CircularProgress
                            size={"1rem"}
                            color="primary" sx={{ animationDuration: "0.7s" }}
                          />
                        </div>

                        <div hidden id={"connected-" + index}>
                          <Tooltip
                            title={routeStatusTooltips.connected}
                            arrow
                            placement="top"
                          >
                            <div
                              data-route-status-badge
                              className="bg-[rgba(0,186,37,0.1)] text-[#166534] text-[12px] lg:text-[13px] px-3 text-center font-semibold rounded-[15px] cursor-help inline-flex items-center"
                            />
                          </Tooltip>
                        </div>

                        <div hidden id={"connected-dev-" + index}>
                          <Tooltip
                            title={routeStatusTooltips.connectedDev}
                            arrow
                            placement="top"
                            disableInteractive={false}
                          >
                            <div
                              data-route-status-badge
                              className="bg-[rgba(245,158,11,0.12)] text-[#92400E] text-[12px] lg:text-[13px] px-3 text-center font-semibold rounded-[15px] cursor-help inline-flex items-center"
                            />
                          </Tooltip>
                        </div>

                        <div hidden id={"disconnected-" + index}>
                          <Tooltip
                            title={routeStatusTooltips.disconnected}
                            arrow
                            placement="top"
                            disableInteractive={false}
                          >
                            <div
                              data-route-status-badge
                              className="bg-[#FEE2E2] text-[#991B1B] text-[12px] lg:text-[13px] px-3 text-center font-semibold rounded-[15px] cursor-help inline-flex items-center"
                            />
                          </Tooltip>
                        </div>
                      </div>
                      <div className="text-[14px] lg:text-[13px] text-gray-500 font-semibold flex items-center">
                        <div>
                          {" "}
                          <Phone className="w-[16px] inline-block mr-2 " />{" "}
                        </div>
                        <div className="text-[14px]">
                          {" "}
                          {formatPhoneNumber(route.configured_phone.S)}{" "}
                        </div>
                      </div>{" "}
                    </div>
                    <div>
                      <Button
                        sx={{
                          textTransform: "none",
                          bgcolor: "white",
                          color: "#555555",
                          py: "5px",
                          px: "10px",
                          borderRadius: "7px",
                          border: "1px solid #E6E8EC",
                          fontSize: { lg: "14px", xs: "12px" },
                          fontWeight: 700,
                        }}
                        onClick={() => {
                          navigate("/dashboard/call-route/" + route.routeId.S);
                        }}
                        //disabled={ ! (/^\(\d{3}\) \d{3}-\d{4}$/.test(call_data.recipient))}
                      >
                        <Edit className="w-[20px] mr-2" />
                        Edit
                      </Button>
                    </div>
                  </div>
                </div>

                {/* <div className="bg-white px-7 py-8 rounded-[20px] flex lg:items-center items-start w-full">
                  <div className="lg:flex lg:space-x-3 space-y-3 lg:space-y-0 flex-1 items-center w-full">
                    <div className="text-[16px] lg:text-[14px] font-semibold">
                      {route.name.S}
                    </div>

                    <div className="bg-[#FAFAFB]  py-2 text-[12px] lg:text-[13px] w-[125px] text-center font-semibold rounded-[15px]">
                      {route.configured_phone.S}
                    </div>

                    <div id={"loader-" + index}>
                      <CircularProgress
                        size={"1rem"}
                        color="primary" sx={{ animationDuration: "0.7s" }}
                      />
                    </div>

                    <div
                      hidden={true}
                      id={"connected-" + index}
                      className="bg-[rgba(0,186,37,0.1)] text-[#3A974C]  py-2 text-[12px] lg:text-[13px] w-[125px] text-center font-semibold rounded-[15px]"
                    >
                      <CircularProgress
                        size={"1rem"}
                        color="primary" sx={{ animationDuration: "0.7s" }}
                      />
                    </div>

                    <div
                      hidden={true}
                      id={"disconnected-" + index}
                      className="bg-[rgba(242,147,57,0.1)] text-[#F29339]  py-2 text-[12px] lg:text-[13px] w-[125px] text-center font-semibold rounded-[15px]"
                    >
                      <CircularProgress
                        size={"1rem"}
                        color="primary" sx={{ animationDuration: "0.7s" }}
                      />
                    </div>

                    
                  </div>

                  <div
                    className="text-[12px] lg:text-[13px] text-brand-primary font-semibold cursor-pointer hover:underline"
                    onClick={() => {
                      navigate("/dashboard/call-route/" + route.routeId.S);
                    }}
                  >
                    Edit
                  </div>
                </div> */}
              </div>
            );
          })
        ) : (
          <></>
        )}

        {/* <div className="bg-[rgba(242,147,57,0.1)] text-[#F29339]  py-2 text-[12px] lg:text-[13px] w-[125px] text-center font-semibold rounded-[15px]">
              Inactive  
            </div> */}

        {routes?.length >= planDetails?.inbound_numbers ? (
          <div className="px-4 lg:px-0">
            <div className="text-center text-[16px] lg:text-[18px] font-semibold mb-2 mt-4">
              Upgrade Plan
            </div>
            <div className="text-center text-[12px] lg:text-[14px]  mb-4">
              You have used all the routes allowed by your plan. To add more,
              please upgrade
            </div>

            <div className="flex justify-center">
              <Button
                variant="contained"
                color="primary"
                sx={{
                  py: "10px",
                  px: "20px",
                  borderRadius: "12px",
                  fontSize: { lg: "14px", xs: "12px" },
                }}
                onClick={() => {
                  navigate("/dashboard/settings/billing");
                }}
              >
                <Add
                  sx={{ fontSize: "20px", position: "relative", bottom: 1 }}
                />
                Upgrade
              </Button>
            </div>
          </div>
        ) : (
          <>
            {routes ? (
              <div className="px-4 lg:px-0">
                <div className="text-center text-[16px] lg:text-[18px] font-semibold mb-2 mt-4">
                  Want to manage multiple numbers dynamically?
                </div>
                <div className="text-center text-[12px] lg:text-[14px]  mb-4">
                  Create additional routes to setup custom routing for each
                  number.
                </div>

                <div className="flex justify-center">
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      py: "10px",
                      px: "20px",
                      borderRadius: "12px",
                      fontSize: { lg: "14px", xs: "12px" },
                    }}
                    disabled={loader}
                    onClick={() => {
                      navigate("/dashboard/create-route");
                    }}
                  >
                    <Add
                      sx={{ fontSize: "20px", position: "relative", bottom: 1 }}
                    />
                    Add Route
                  </Button>
                </div>
              </div>
            ) : (
              <div className="px-4 lg:px-0">
                <div className="text-center text-[16px] lg:text-[18px] font-semibold mb-2 mt-4">
                  You do not have any routes created yet.
                </div>
                <div className="text-center text-[12px] lg:text-[14px]  mb-4">
                  Click the "Add Route" button to create one. Need help?{" "}
                  <a
                    className="hover:underline hover:text-blue-600 cursor-pointer"
                    href={"mailto:hello@twilanswer.com"}
                  >
                    Contact Support
                  </a>
                  .
                </div>

                <div className="flex justify-center">
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      py: "5px",
                      px: "10px",
                      borderRadius: "7px",
                      fontSize: { lg: "14px", xs: "12px" },
                      fontWeight: 700,
                    }}
                    onClick={() => {
                      navigate("/dashboard/create-route");
                    }}
                    //disabled={ ! (/^\(\d{3}\) \d{3}-\d{4}$/.test(call_data.recipient))}
                  >
                    <Plus className="w-[20px]" />
                    New Route
                  </Button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default CallRoutings;
